import {
  withTranslation,
} from 'react-i18next';

import EmptyTableView from './EmptyTableView';

const TranslatedComponent = withTranslation()(EmptyTableView);

const Component = TranslatedComponent;

export default Component;
